import { PartyPopper, RotateCcw, XCircle } from "lucide-react";

import { isTerminalPayinStatus } from "@/modules/dashboard/payins/hooks/usePayinLiveStatus";
import { PayinRuntimeStatus } from "@/modules/dashboard/payins/services/paymentsPayin.service";
import useTranslations from "@/shared/lang/useTranslations";

/**
 * What became of a collection while its panel was open: credited, refused, or credited and then taken back.
 * Nothing while it is still payable. Shared by every wallet deposit panel, so a paid PIX, SPEI or Bre-B
 * collection says so the same way.
 */
export function DepositOutcomeBanner({ status }: { status: PayinRuntimeStatus | null }) {
  const { t } = useTranslations("wallets");
  if (status === PayinRuntimeStatus.CONFIRMED) {
    return (
      <div className="flex items-start gap-3 rounded-xl border border-success/30 bg-success-container p-4">
        <PartyPopper className="size-6 shrink-0 text-success" aria-hidden="true" />
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-success-container-foreground">{t("deposit_paid_title")}</p>
          <p className="mt-0.5 text-sm text-success-container-foreground/80">{t("deposit_paid_text")}</p>
        </div>
      </div>
    );
  }
  // Credited and then taken back: not a refusal.
  if (status === PayinRuntimeStatus.REVERSED) {
    return (
      <div className="flex items-start gap-3 rounded-xl border border-warning/30 bg-warning-container p-4">
        <RotateCcw className="size-6 shrink-0 text-warning" aria-hidden="true" />
        <p className="text-sm text-warning-container-foreground">{t("deposit_reversed_text")}</p>
      </div>
    );
  }
  if (isTerminalPayinStatus(status)) {
    return (
      <div className="flex items-start gap-3 rounded-xl border border-destructive/30 bg-destructive/10 p-4">
        <XCircle className="size-6 shrink-0 text-destructive" aria-hidden="true" />
        <p className="text-sm text-destructive">{t("deposit_rejected_text")}</p>
      </div>
    );
  }
  return null;
}
